import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import TabWizard from "../components/propertyUpload/TabWizard";

const PropertyUploadPage = () => {
  return (
    <>
      <Header />
      <TabWizard />
      <Footer />
    </>
  );
};

export default PropertyUploadPage;
